<template lang="pug">
  app-dialog(v-model="$_show" :header="headerText" :confirm-text="confirmText" :confirm-disabled="isNotReady" @confirm="createOrg" width="756")
        v-form(ref="addOrgForm" v-model="valid")
          app-select(v-if="isOrganizationCategoriesLoaded" v-model="form.organizationCategory" :items="organizationCategories" label="Категория" item-text="title" :rules="[rules.required]")
          app-text-field(v-model="form.name" label="Название" :rules="[rules.required]")
          app-text-field(v-model="form.alias" label="Алиас")
          app-text-field(v-model="form.city" label="Город" :rules="[rules.required]")
          app-text-field(v-model="form.address" label="Адрес" :rules="[rules.required]")
          app-text-field(v-model="form.phone" label="Телефон" :rules="[rules.required]" v-mask="mask.phone")
          app-text-field(v-model="form.fax" label="Факс" :rules="[rules.required]" v-mask="mask.phone")
          app-text-field(v-model="form.email" label="E-mail" :rules="[rules.email]")
          app-text-field(v-model="form.site" label="Сайт" :rules="[rules.required]")
          app-select(v-if="sendChannels.length > 0" v-model="form.sendChannel" :items="sendChannels" label="Тип доставки" item-text="title" :rules="[rules.required]")

          v-btn.mx-0(@click="$refs.localfile.click()") Файл сертификата
            v-icon(right dark) attach_file
          input(id="org-upload-file-id" type="file" style="display: none" ref="localfile" @change="changeFile" :accept="acceptFormats" )
          .wrap.mt-1 {{ newFile }}

</template>

<script>
import { AppDialogToggable } from '@/components'
import { $_validate_rules } from '@/common/ValidateRules'
import { organizationService, caseService } from '@/_services'

import {mask} from 'vue-the-mask'

export default {
  mixins: [AppDialogToggable, $_validate_rules],
  directives: {mask},
  props: {
    org: null,
  },
  data () {
    const defaultForm = Object.freeze({
      id: null,
      name: '', 
      organizationCategory: null,
      alias: '', 
      city: '', 
      address: '', 
      phone: '', 
      fax: '', 
      email: '', 
      site: '', 
      sendChannel: null,
      cert: null
    })

    return {
      mask: {
        phone: '+7 (###) ### ####',
      },
      valid: false,
      form: Object.assign({}, defaultForm),
      defaultForm,
      organizationCategories: null,
      isOrganizationCategoriesLoaded: false,
      sendChannels: [],
      newFile: ''
    }
  },
  methods: {
    createOrg() {
      if (this.$refs.addOrgForm.validate()) {
          if(this.form.id==null)
              this.$store.dispatch('organization/CREATE_ORG', this.form)
          else
              this.$store.dispatch('organization/UPDATE_ORG', this.form)
      }
    },
    changeFile () {
      let input = document.getElementById('org-upload-file-id')
      let file = input.files[0]
      this.newFile = file.name

      let self = this
      var reader = new FileReader()
      reader.onload = function(e) {
        self.form.cert=e.target.result
      }
      reader.readAsText(file)

    },
  },
  watch: {
    $_show (value) {
      if (value) {
        let baseObj = this.org || this.defaultForm
        this.form = JSON.parse(JSON.stringify(baseObj))
      }
    },
  },
  computed: {
    isNotReady () {
      if(!this.valid) return true
      return false
    },
    confirmText() {
      return this.org!=null ? "Редактировать" : "Добавить"
    },
    headerText() {
      return this.org!=null ? "Редактировать организацию" : "Добавить организацию"
    },
    acceptFormats () {
      let types = [
        'application/x-x509-ca-cert'
      ]
      return types
    },

  },
  created() {
    caseService.sendChannels()
    .then(data => {
      this.sendChannels=data
    })

    organizationService.orgcategories()
    .then(data => {
      this.organizationCategories=data
      this.isOrganizationCategoriesLoaded=true
    })
  }
}
</script>

<style lang="scss" scoped>

</style>

